import { render, staticRenderFns } from "./SimuladorPassoConsorcio.vue?vue&type=template&id=45902a64&scoped=true&"
import script from "./SimuladorPassoConsorcio.vue?vue&type=script&lang=js&"
export * from "./SimuladorPassoConsorcio.vue?vue&type=script&lang=js&"
import style0 from "./SimuladorPassoConsorcio.vue?vue&type=style&index=0&id=45902a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45902a64",
  null
  
)

export default component.exports